<i
  class="status-icon"
  [ngClass]="isReady ? readyIcon : notReadyIcon"
  [matTooltip]="rental?.status | rentalStatus"
  matTooltipPosition="left"
></i>
